import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import Tooltip from "components/Tooltip";

import { useWorkDeskEnabled } from "../hooks";

// Isolates the LaunchDarkly and advisor-store subscriptions of
// useWorkDeskEnabled so flag or advisor updates do not re-render the whole
// workspace container. Renders the two-state Start/Exit control from the
// descriptor the container computes; the self-serve preference (or the
// work-desk-beta fallback) decides whether it shows at all.
function StartWorkSessionButton({ button }) {
  const workDeskEnabled = useWorkDeskEnabled();

  if (!workDeskEnabled) return null;

  return (
    <Tooltip title={button.tooltip}>
      <Button
        color={button.color}
        data-test="hub-menu-workdesk"
        onClick={button.onClick}
        onMouseEnter={button.onHoverIntent}
        style={{ marginRight: "0.5em" }}
        icon={button.icon}
        content={
          <span
            style={{
              display: "inline-block",
              width: "170px",
              textAlign: "center",
            }}
          >
            {button.content}
          </span>
        }
        label={{
          color: "blue",
          content: <span style={{ color: "#e2923a" }}>Beta</span>,
        }}
        labelPosition="right"
      />
    </Tooltip>
  );
}

StartWorkSessionButton.propTypes = {
  button: PropTypes.shape({
    content: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    onHoverIntent: PropTypes.func,
  }).isRequired,
};

export default StartWorkSessionButton;
